import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';

export const StyledHeader = styled.h2<{ color: string; paddingBottom: string }>`
    background-color: ${(props) => props.theme.shades.white};
    font-size: ${(props) => props.theme.fontSize.headlineS};
    color: ${(props) =>
        props.color === 'light' ? props.theme.shades.white : props.theme.shades.blackGrey};
    font-weight: 700;
    text-align: center;
    padding: ${(props) => props.theme.spacing.xxLarge} 0 ${(props) => props.paddingBottom};
    margin: 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /* not in globalstyles */
    line-height: 25px;

    @media ${mediaQueries.tabletAndUp} {
        background-color: ${(props) => props.theme.shades.whiteGrey};
        padding-top: 0px;
        font-size: ${(props) => props.theme.fontSize.headlineM};
        font-weight: 700;
        text-align: center;
    }
`;
export const StyledChunk = styled.span`
    padding-right: 2px;
    padding-left: 2px;
`;
